import React, { useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import TextField from '../../components/elements/form/TextField'
import PasswordField from '../../components/elements/form/PasswordField'
import FormButton from '../../components/elements/form/FormButton'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { ERROR } from '../../store/types'

const Login = () => {
    let navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [processing, setProcessing] = useState(false)
    const dispatch = useDispatch()

    const [validationErrors, setValidationErrors] = useState({})  
    const location = useLocation()

    const validateForm = () => {
        let errors = {}
        if(!email || email === '') {
            errors.email = true
        }
        if(!password || password === '') {
            errors.password = true
        }
        setValidationErrors(errors)

        return errors
    }


    const logIn = async  () => {
        const headers = {
            'Content-Type': 'application/json'
        }
        
        if (Object.values(validateForm()).includes(true)) {

            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        setProcessing(true)

        const requestPayload = { email, password }
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/sessions`, requestPayload, { headers })            

            localStorage.setItem("authToken", JSON.stringify(response.data.data.accessToken));
            getUserProfile(response.data.data.accessToken)
        } catch (error) {
            console.log(error

            )
            dispatch({
                type: ERROR,
                error
            })
            setProcessing(false)
        }
    }

    const getUserProfile = async  (token) => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/user/profile?expand=parentProfile`, { headers })            

            localStorage.setItem("userDetails", JSON.stringify(response.data.data));

            // navigate("/user")
            const returnUrl = new URLSearchParams(location.search).get('returnUrl')
            const destination = returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')
                ? returnUrl
                : '/user'

            navigate(destination, { replace: true })
        } catch (error) {
            dispatch({
                type: ERROR,
                error
            })
            setProcessing(false)
        }
    }

    return (
        <div className="relative flex flex-row items-center justify-center w-full bg-vcm-light-purple bg-opacity-5 min-h-screen h-inherit">
            <div className="w-11/12 lg:w-6/12 xl:w-4/12 p-4 lg:p-8 2xl:p-12 rounded-[8px] bg-white">
                <h1 className="text-xl font-thin text-primary mb-5 text-opacity-80 tracking-[0.2em] uppercase">vaatia college makurdi</h1>

                <p className="">Please provide your email address and password to proceed</p>

                <div className='w-full mt-2'>
                    <p className='text-gray-600 text-sm'>Don't have an account yet? <Link className='text-blue-500 font-[500]' to='signup'>Set up your account here</Link></p>
                </div>

                <div className='mt-4'>
                    <TextField
                        inputLabel="Your email address" 
                        fieldId="email" 
                        inputType="text" 
                        preloadValue={''}
                        hasError={validationErrors && validationErrors.email} 
                        returnFieldValue={(value)=>{setEmail(value)}}
                        inputPlaceholder={`Your registered email`}
                    />
                </div>
                
                <div className='mt-4'>
                    <PasswordField
                        inputLabel="Password" 
                        fieldId="password" 
                        inputType="password" 
                        preloadValue={''}
                        inputPlaceholder={`Your password`}
                        hasError={validationErrors && validationErrors.password} 
                        returnFieldValue={(value)=>{setPassword(value)}}
                    />
                </div>

                <p className="my-3 text-sm text-opacity-70 block">Forgot your password? <Link to="/password-reset" className="text-blue-600">Click here to reset it</Link></p>
                
                <div className='mt-8'>
                    <FormButton buttonLabel="Login to your account" buttonAction={()=>{logIn()}} processing={processing} />
                </div>

            </div>    
        </div>
    )
}

export default Login